import { Group, Paper } from "@mantine/core";
import type { ReactNode } from "react";
import { axioTokens } from "../../theme";

export const CLEAR_FILTERS_LABEL = "Clear filters";

interface FilterBarProps {
  children: ReactNode;
  actions?: ReactNode;
}

export function FilterBar({ children, actions }: FilterBarProps) {
  return (
    <Paper
      withBorder

      p="lg"
      style={{ borderColor: axioTokens.border, boxShadow: "none" }}
    >
      <Group justify="space-between" wrap="wrap" gap="md">
        <Group wrap="wrap" gap="md">
          {children}
        </Group>
        {actions}
      </Group>
    </Paper>
  );
}
